module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "document-share"
    }
  }, [_c('document-set-header', {
    attrs: {
      "document-set": _vm.store.data.currentDocumentSet
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareStatus == 'init'),
      expression: "shareStatus == 'init'"
    }],
    staticClass: "row",
    attrs: {
      "id": "document-share-form"
    }
  }, [_c('div', {
    staticClass: "document-list col-xs-12"
  }, [_c('h3', [_vm._v("Sending " + _vm._s(_vm.toShare.length) + " document"), (_vm.toShare.length != 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(":")]), _vm._v(" "), _vm._l((_vm.toShare), function(document) {
    return _c('div', {
      staticClass: "document well well-sm clearfix"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(document.title))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs action",
      on: {
        "click": function($event) {
          return _vm.removeItem(document.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "recipients-block col-xs-12"
  }, [_c('h3', [_vm._v("To:")]), _vm._v(" "), _vm._l((_vm.recipients), function(recipient) {
    return _c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "recipient col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (recipient.email),
        expression: "recipient.email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "email",
        "placeholder": "Recipient email"
      },
      domProps: {
        "value": (recipient.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(recipient, "email", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs action removeRecipient",
      on: {
        "click": function($event) {
          return _vm.removeRecipient(recipient)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
      staticClass: "alert alert-danger"
    }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary",
    on: {
      "click": _vm.addRecipient
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" Add recipient")]), _vm._v(" "), (_vm.recipients.length) ? _c('button', {
    staticClass: "btn btn-md btn-success",
    on: {
      "click": _vm.processInvitation
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Send")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": {
        name: 'DocumentsView'
      }
    }
  }, [_vm._v("Cancel")])], 1)], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareStatus == 'success'),
      expression: "shareStatus == 'success'"
    }],
    staticClass: "row",
    attrs: {
      "id": "document-share-status"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "id": "success"
    }
  }, [_c('h2', [_vm._v("Your documents have been shared.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": {
        name: 'DocumentsView'
      }
    }
  }, [_vm._v("OK!")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22bdaf80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentsShare.vue
// module id = 275
// module chunks = 1